export default __webpack_public_path__ + "static/media/alert-circle.115a1493.svg";